// extracted by mini-css-extract-plugin
export default {"background":"modal_background__iObeN","modalContent":"modal_modalContent__vA2zy","title":"modal_title__PCobi"};